/**
 * HandyMite: 営業日カレンダー（JST 当月・土日休み・日本の国民の祝日）
 * V4.6の祝日表を維持し、店舗休業日だけを追加する。
 */
(function () {
  const TIME_ZONE = 'Asia/Tokyo';

  const JP_HOLIDAYS = new Set(
    '2024-01-01,2024-01-08,2024-02-11,2024-02-12,2024-02-23,2024-03-20,2024-04-29,2024-05-03,2024-05-04,2024-05-05,2024-05-06,2024-07-15,2024-08-11,2024-08-12,2024-09-16,2024-09-22,2024-09-23,2024-10-14,2024-11-03,2024-11-04,2024-11-23,2025-01-01,2025-01-13,2025-02-11,2025-02-23,2025-02-24,2025-03-20,2025-04-29,2025-05-03,2025-05-04,2025-05-05,2025-05-06,2025-07-21,2025-08-11,2025-09-15,2025-09-23,2025-10-13,2025-11-03,2025-11-23,2025-11-24,2026-01-01,2026-01-12,2026-02-11,2026-02-23,2026-03-20,2026-04-29,2026-05-03,2026-05-04,2026-05-05,2026-05-06,2026-07-20,2026-08-11,2026-09-21,2026-09-22,2026-09-23,2026-10-12,2026-11-03,2026-11-23,2027-01-01,2027-01-11,2027-02-11,2027-02-23,2027-03-21,2027-03-22,2027-04-29,2027-05-03,2027-05-04,2027-05-05,2027-07-19,2027-08-11,2027-09-20,2027-09-23,2027-10-11,2027-11-03,2027-11-23,2028-01-01,2028-01-10,2028-02-11,2028-02-23,2028-03-20,2028-04-29,2028-05-03,2028-05-04,2028-05-05,2028-07-17,2028-08-11,2028-09-18,2028-09-22,2028-10-09,2028-11-03,2028-11-23,2029-01-01,2029-01-08,2029-02-11,2029-02-12,2029-02-23,2029-03-20,2029-04-29,2029-04-30,2029-05-03,2029-05-04,2029-05-05,2029-07-16,2029-08-11,2029-09-17,2029-09-23,2029-09-24,2029-10-08,2029-11-03,2029-11-23,2030-01-01,2030-01-14,2030-02-11,2030-02-23,2030-03-20,2030-04-29,2030-05-03,2030-05-04,2030-05-05,2030-05-06,2030-07-15,2030-08-11,2030-08-12,2030-09-16,2030-09-23,2030-10-14,2030-11-03,2030-11-04,2030-11-23'.split(',')
  );

  /* 日本の国民祝日ではないが、HandyMiteが休業する定例日。 */
  const STORE_FIXED_CLOSED_MMDD = new Set(['08-13', '08-14', '08-15', '08-16']);

  /** グレゴリオ暦の civil 日付の曜日（0=日 … 6=土）Tomohiko Sakamoto */
  function civilWeekdaySunday0(year, month1to12, day) {
    const t = [0, 3, 2, 5, 0, 3, 5, 1, 4, 6, 2, 4];
    let y = year;
    if (month1to12 < 3) y -= 1;
    return (
      y +
      Math.floor(y / 4) -
      Math.floor(y / 100) +
      Math.floor(y / 400) +
      t[month1to12 - 1] +
      day
    ) % 7;
  }

  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function isoDate(year, month1to12, day) {
    return `${year}-${pad2(month1to12)}-${pad2(day)}`;
  }

  function monthDay(month1to12, day) {
    return `${pad2(month1to12)}-${pad2(day)}`;
  }

  function nowTokyoDate() {
    const fmt = new Intl.DateTimeFormat('en-CA', {
      timeZone: TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
    const parts = fmt.formatToParts(new Date());
    const y = Number(parts.find((p) => p.type === 'year').value);
    const m = Number(parts.find((p) => p.type === 'month').value);
    const d = Number(parts.find((p) => p.type === 'day').value);
    return { year: y, month: m, day: d };
  }

  function addMonthOffset(year, month1to12, offset) {
    const zeroBased = month1to12 - 1 + offset;
    return {
      year: year + Math.floor(zeroBased / 12),
      month: (zeroBased % 12) + 1,
    };
  }

  function lastDayOfMonth(year, month1to12) {
    return new Date(Date.UTC(year, month1to12, 0)).getUTCDate();
  }

  function parseExtraClosed(raw) {
    if (!raw || typeof raw !== 'string') return new Set();
    return new Set(
      raw
        .split(/[\s,]+/)
        .map((s) => s.trim())
        .filter(Boolean)
    );
  }

  function isRegularClosedDay(iso, dow0) {
    if (dow0 === 0 || dow0 === 6) return true;
    if (JP_HOLIDAYS.has(iso)) return true;
    return false;
  }

  function renderMonth(monthRoot, year, month, today, extraClosed) {
    const tbody = monthRoot.querySelector('[data-hm-cal-body]');
    const monthEl = monthRoot.querySelector('[data-hm-cal-month]');
    const yearEl = monthRoot.querySelector('[data-hm-cal-year]');
    const captionEl = monthRoot.querySelector('[data-hm-cal-caption]');
    if (!tbody || !monthEl || !yearEl || !captionEl) return;

    const lastDay = lastDayOfMonth(year, month);
    const firstDow = civilWeekdaySunday0(year, month, 1);

    monthEl.textContent = month;
    yearEl.textContent = year;
    captionEl.textContent = `${year}年${month}月 営業日カレンダー`;

    const rows = [];
    let cells = [];

    for (let i = 0; i < firstDow; i++) {
      cells.push('<td><div class="hm-day hm-day--empty" aria-hidden="true">0</div></td>');
    }

    for (let day = 1; day <= lastDay; day++) {
      const dow = civilWeekdaySunday0(year, month, day);
      const iso = isoDate(year, month, day);
      const extraClosedDay = extraClosed.has(iso);
      const storeFixedClosedDay = STORE_FIXED_CLOSED_MMDD.has(monthDay(month, day));
      const regularClosedDay = isRegularClosedDay(iso, dow);
      const storeClosedDay = extraClosedDay || storeFixedClosedDay;
      const statusClass = storeClosedDay
        ? 'hm-day--extra-closed'
        : regularClosedDay
          ? 'hm-day--regular-closed'
          : 'hm-day--open';
      const weekdayClass = dow === 0 ? ' hm-day--sunday' : dow === 6 ? ' hm-day--saturday' : '';
      const todayClass = iso === today ? ' hm-day--today' : '';
      const statusLabel = storeClosedDay ? '店舗休業日' : regularClosedDay ? '定休日' : '営業日';
      cells.push(
        `<td><div class="hm-day ${statusClass}${weekdayClass}${todayClass}" aria-label="${year}年${month}月${day}日 ${statusLabel}">${day}</div></td>`
      );
      if (cells.length === 7) {
        rows.push(`<tr>${cells.join('')}</tr>`);
        cells = [];
      }
    }

    if (cells.length) {
      while (cells.length < 7) {
        cells.push('<td><div class="hm-day hm-day--empty" aria-hidden="true">0</div></td>');
      }
      rows.push(`<tr>${cells.join('')}</tr>`);
    }

    tbody.innerHTML = rows.join('');
  }

  function render(root) {
    const extraRaw = root.getAttribute('data-extra-closed') || '';
    const extraClosed = parseExtraClosed(extraRaw);
    const current = nowTokyoDate();
    const today = isoDate(current.year, current.month, current.day);

    root.querySelectorAll('[data-hm-month]').forEach((monthRoot) => {
      const offset = Number(monthRoot.getAttribute('data-month-offset') || '0');
      const target = addMonthOffset(current.year, current.month, offset);
      renderMonth(monthRoot, target.year, target.month, today, extraClosed);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-hm-business-calendar]').forEach(render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
